import {
  reviewSchema,
  type ListResult,
  type PaginationParams,
  type Review,
} from '../model';
import { getList, type RequestOptions } from './http';

// Review Service — read-only customer ratings, either across the merchant or
// for one branch.

export const reviewApi = {
  /** List reviews across every branch of the merchant. */
  listByMerchant(
    params?: PaginationParams,
    options?: RequestOptions,
  ): Promise<ListResult<Review>> {
    return getList('merchant/reviews', reviewSchema, params, options);
  },

  /** List one branch's reviews. */
  listByRestaurant(
    restaurantId: string,
    params?: PaginationParams,
    options?: RequestOptions,
  ): Promise<ListResult<Review>> {
    return getList(
      'merchant/reviews/by-restaurant',
      reviewSchema,
      { ...params, restaurant_id: restaurantId },
      options,
    );
  },
};
